import React from 'react';
import './btnCloseModal.css';

const BtnCloseModal = () => {
  return (
    <>
      <button className="btnCloseModal">x</button>
    </>
  );
};

export default BtnCloseModal;
